export default __webpack_public_path__ + "static/media/toyota5.dc257e2d.png";